import i18n from "@/i18n";

export enum ProcessingTestStatus {
  ReadyForProcessing = "readyForProcessing",
  InProcessing = "inProcessing",
  ReadyForApproval = "readyForApproval",
  InApproval = "inApproval",
  InReporting = "inReporting",
  Aborted = "aborted",
}

export const PROCESSING_STATUSES = new Set<string>([
  ProcessingTestStatus.ReadyForProcessing,
  ProcessingTestStatus.InProcessing,
  ProcessingTestStatus.ReadyForApproval,
  ProcessingTestStatus.InApproval,
  ProcessingTestStatus.InReporting,
]);

export const getProcessingTestStatusLabels = (): Record<ProcessingTestStatus, string> => ({
  [ProcessingTestStatus.ReadyForProcessing]: i18n.t("common:processingTestStatus.readyForProcessing"),
  [ProcessingTestStatus.InProcessing]: i18n.t("common:processingTestStatus.inProcessing"),
  [ProcessingTestStatus.ReadyForApproval]: i18n.t("common:processingTestStatus.readyForApproval"),
  [ProcessingTestStatus.InApproval]: i18n.t("common:processingTestStatus.inApproval"),
  [ProcessingTestStatus.InReporting]: i18n.t("common:processingTestStatus.inReporting"),
  [ProcessingTestStatus.Aborted]: i18n.t("common:processingTestStatus.aborted"),
});
